import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import Title from "segments/desktop/core-components/title/title";
import { XS } from "constants/sizes";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { StyledProductCardTitle } from "./product-card-title.scss";
const ProductCardTitle = ({ color, productImage, body, title })=>/*#__PURE__*/ _jsxs(StyledProductCardTitle, {
        className: "product-card-title",
        children: [
            /*#__PURE__*/ _jsx(PictureComponent, {
                src: productImage
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card-title-text",
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        titleColor: color,
                        titleClassName: "main-title",
                        title: title
                    }),
                    /*#__PURE__*/ _jsx(Paragraph, {
                        bodyColor: "asphalt",
                        body: body,
                        textSize: XS
                    })
                ]
            })
        ]
    });
export default ProductCardTitle;
